var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLineDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9779 22.9027C28.3876 22.5174 28.3876 21.876 27.9779 21.4772C27.5821 21.0919 26.9234 21.0919 26.5285 21.4772L19.1042 28.7054L19.1042 4.85342C19.1033 4.2974 18.6494 3.85547 18.0783 3.85547C17.5072 3.85547 17.0385 4.2974 17.0385 4.85342L17.0385 28.7054L9.62801 21.4772C9.21837 21.0919 8.55869 21.0919 8.16381 21.4772C7.75418 21.876 7.75418 22.5183 8.16381 22.9027L17.3457 31.8421C17.7415 32.2409 18.4002 32.2409 18.7951 31.8421L27.9779 22.9027Z",
    fill: "#005FC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLineDown);
export default __webpack_public_path__ + "static/media/arrow-line-down.b4548423ce44ef6332811c9130ed651b.svg";
export { ForwardRef as ReactComponent };